namespace GeniuzPOS.CustomReport {
    export class ReportCusSaleComparisonColumns {
        static columnsKey = 'CustomReport.ReportCusSaleComparison';
    }
}
